import {connect} from "react-redux";
import TollList from "./list";
import {bindActionCreators} from "redux";
import {listToll, tollFilter} from "../../../../service/FasttagToll/action";
import {getCityByStateId} from "../../../../service/Account/action";
const mapStateToProps = (state) => ({
    tollListDetails:state.FasttagToll.tollList,
    filter:state.FasttagToll.filter,
    geoCity:state.Dropdown.geoCity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            listToll,
            tollFilter,
            getCityByStateId
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TollList);
